export default __webpack_public_path__ + "static/media/menu.cd587b01.svg";